import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { CardSolicitacaoOptions } from "../../../components/CardSolicitacaoOptions";
import { DynamicRadio } from "../../../components/DynamicRadio";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { useForm } from 'react-hook-form';
import { DateRangeInput } from "@datepicker-react/styled";
import api from '../../../services/api';
import { DynamicCheckbox } from '../../../components/DynamicCheckbox';
import { Multiselect } from 'multiselect-react-dropdown';
import { MobileContext } from "../../../contexts/MobileContext";
import { getSinisterStatus, getSinisterPort, getSinisterTypes } from '../../../services/sinistro';
import { getCorretoras } from '../../../services/corretoras';
import { getReguladoras } from '../../../services/reguladoras';
import { getClients } from '../../../services/clientes';
import { getDisciplinas } from '../../../services/disciplinas';

const typeOptions = [
    { value: "civil", name: "tipo", label: "Civil" },
    { value: "eletrica", name: "tipo", label: "Elétrica" },
    { value: "mecanica", name: "tipo", label: "Mecânica" },
];

const initialState = {
    startDate: null,
    endDate: null,
    focusedInput: null,
};

function reducer(state, action) {
    switch (action.type) {
        case "focusChange":
            return { ...state, focusedInput: action.payload };
        case "dateChange":
            return action.payload;
        default:
            throw new Error();
    }
}

const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada' };

const defaultTypeOptions = [
    {
        "idDisciplina": 1,
        "titulo": "Civil"
    },
    {
        "idDisciplina": 2,
        "titulo": "Elétrica"
    },
    {
        "idDisciplina": 3,
        "titulo": "Mecânica"
    }
];

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

const fillTypeOptions = (typeOptions) => {
    const options = [];
    typeOptions.forEach(option => options.push({ value: option.idDisciplina, name: 'tipo', label: option.titulo }));
    return options;
}

const getListaSolicitacoes = async (formValues, currentPage, pageSize) => {
    let list = null;
    let params = `Start=${currentPage}&Length=${pageSize}`;
    if (formValues.data != null) {
        if (formValues.search.length > 0) {
            params += `&Search=${formValues.search}`;
        }
        if (formValues.data.IdentificaoSolicitacao.length > 0) {
            params += `&IdentificaoSolicitacao=${formValues.data.IdentificaoSolicitacao}`;
        }
        if (formValues.data.Segurado.length > 0) {
            params += `&Segurado=${formValues.data.Segurado}`;
        }
        if (formValues.data.Contato.length > 0) {
            params += `&Contato=${formValues.data.Contato}`;
        }
        if (formValues.data.Endereco.length > 0) {
            params += `&Endereco=${formValues.data.Endereco}`;
        }
        if (formValues.idDisciplinas > 0) {
            params += `&Disciplinas=${formValues.idDisciplinas}`;
        }
        if (formValues.idCliente > 0) {
            params += `&IdCliente=${formValues.idCliente}`;
        }
        if (formValues.idReguladora > 0) {
            params += `&IdReguladora=${formValues.idReguladora}`;
        }
        if (formValues.idCorretora > 0) {
            params += `&IdCorretora=${formValues.idCorretora}`;
        }
        if (formValues.idTipoSinistro > 0) {
            params += `&IdTipoSinistro=${formValues.idTipoSinistro}`;
        }
        if (formValues.idStatus > 0) {
            params += `&Status=${formValues.idStatus}`;
        }
        if (formValues.startDate.length > 0) {
            params += `&PeriodoInicial=${formValues.startDate}`;
        }
        if (formValues.endDate.length > 0) {
            params += `&PeriodoFinal=${formValues.endDate}`;
        }
    }
    try {
        const response = await api.get(`Solicitacao/list?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const Solicitacoes = () => {
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [typeOptions, setTypeOptions] = useState(fillTypeOptions(defaultTypeOptions));
    let [solicitacoesData, setSolicitacoesData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const { register, handleSubmit, reset } = useForm();
    const [disciplinaList, setDisciplinaList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [reguladoraList, setReguladoraList] = useState([]);
    const [corretoraList, setCorretoraList] = useState([]);
    const [sinisterType, setSinisterType] = useState([]);
    const [sinisterPort, setSinisterPort] = useState([]);
    const [sinisterStatus, setSinisterStatus] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    var [reguladora, setReguladora] = useState(null);
    var [idReguladora, setIdReguladora] = useState(null);
    var [corretora, setCorretora] = useState(null);
    var [idCorretora, setIdCorretora] = useState(null);
    var [disciplina, setDisciplina] = useState(null);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [porteSinistro, setPorteSinistro] = useState(null);
    var [idPorteSinistro, setIdPorteSinistro] = useState(null);
    var [status, setstatus] = useState(null);
    var [idStatus, setIdStatus] = useState(null);
    var [tipoSinistro, setTipoSinistro] = useState(null);
    var [idTipoSinistro, setIdTipoSinistro] = useState(null);
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const multiselectRef = useRef();

    const formSubmit = async (data) => {
        formData(data, 1, 10);
    }

    const formData = async (data = null, currentPage = 1, pageSize = 10) => {

        let formValues = {
            data: data,
            search: 0,
            idDisciplinas: idDisciplinas,
            idCliente: idCliente,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idStatus: idStatus,
            startDate: new Date(state.startDate),
            endDate: new Date(state.endDate)
        };

        setCurrentPage(currentPage);
        setPageSize(pageSize);

        const solicitacoes = await getListaSolicitacoes(formValues, currentPage, pageSize);
        if (solicitacoes.data.itens.length > 0) {
            pageSize = solicitacoes.data.page.length;
            setSolicitacoesData(solicitacoes);
        }
    };

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getReguladora = (currentValue, value) => {
        var reguladoraResult = reguladoraList.filter(function (o) {
            return o.idReguladora == value;
        });
        reguladora = reguladoraResult[0].reguladora;
        idReguladora = reguladoraResult[0].idReguladora;
        setReguladora(reguladora);
        setIdReguladora(idReguladora);
    };

    const getCorretora = (currentValue, value) => {
        var corretoraResult = corretoraList.filter(function (o) {
            return o.idCorretora == value;
        });
        corretora = corretoraResult[0].corretora;
        idCorretora = corretoraResult[0].idCorretora;
        setCorretora(corretora);
        setIdCorretora(idCorretora);
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        disciplina = value.titulo;
        setDisciplina(disciplina);

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    };

    const onRemoveDisciplina = (currentValue, value) => { }

    const getSearch = async (currentValue, value, pageSize) => {


        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            Contato: null,
            Endereco: null
        }

        if (currentValue.length >= 3) {
            let formValues = {
                data: data,
                search: currentValue,
                idDisciplinas: null,
                idCliente: null,
                idReguladora: null,
                idCorretora: null,
                idTipoSinistro: null,
                idPorteSinistro: null,
                idStatus: idStatus,
                startDate: null,
                endDate: null
            };
            setCurrentPage(currentPage);
            setPageSize(pageSize);
            const solicitacoes = await getListaSolicitacoes(formValues, currentPage, pageSize);
            if (solicitacoes.data.itens.length > 0) {
                pageSize = solicitacoes.data.itens.length;
                setSolicitacoesData(solicitacoes);
            }
        }
    };

    const getCliente = (currentValue, value) => {
        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getPorteSinistro = (currentValue, value) => {
        var porteSinistroResult = sinisterPort.filter(function (o) {
            return o.key == value;
        });

        porteSinistro = porteSinistroResult[0].value;
        idPorteSinistro = porteSinistroResult[0].key;
        setPorteSinistro(porteSinistro);
        setIdPorteSinistro(idPorteSinistro);
    };

    const getTipoSinistro = (currentValue, value) => {
        var tipoSinistroResult = sinisterType.filter(function (o) {
            return o.key == value;
        });
        tipoSinistro = tipoSinistroResult[0].value;
        idTipoSinistro = tipoSinistroResult[0].key;
        setTipoSinistro(tipoSinistro);
        setIdTipoSinistro(idTipoSinistro);
    };

    const getstatus = (currentValue, value) => {
        var statusResult = sinisterStatus.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setstatus(status);
        setIdStatus(idStatus);
    };


    useEffect(() => {
        const asyncFn = async () => {
            const disciplinas = await getDisciplinas();
            if (!!disciplinas) {
                setDisciplinaList(disciplinas);
            }

            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const reguladoras = await getReguladoras();
            if (!!reguladoras) {
                setReguladoraList(reguladoras)
            }

            const corretoras = await getCorretoras();
            if (!!corretoras) {
                setCorretoraList(corretoras)
            }

            const sinisterPorts = await getSinisterPort(21);
            if (!!sinisterPorts) {
                setSinisterPort(sinisterPorts)
            }

            const sinisterTypes = await getSinisterTypes(20);
            if (!!sinisterTypes) {
                setSinisterType(sinisterTypes)
            }

            const sinisterStatus = await getSinisterStatus(2);
            if (!!sinisterStatus) {
                setSinisterStatus(sinisterStatus)
            }

            formData(null, 1, 10);
        }
        asyncFn()
    }, []);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">Solicitações</h5>
                            <IconRefresh color={"#EE4B21"} />
                        </div>
                        <Link to={"/nova-solicitacao"}>
                            <ButtonOutline
                                outlineColor={"#EE4B21"}
                                backgroundColor={"#EE4B21"}
                                color={"#FFF"}
                                text={"Nova Solicitação"}
                                maxWidth={"280px"}
                            />
                        </Link>
                    </div>

                    <div className="card">

                        <StyledForm onSubmit={handleSubmit(formSubmit)}>

                            <div className="form-wrapper filter-container">
                                {/* <DynamicCheckbox options={typeOptions} setCheckData={(collection) => setTypeOptions(collection)} /> */}

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} />
                                </div>

                                <div className="form-container d-flex flex-column justify-content-center">
                                    <ToggleSwitch config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                                </div>

                            </div>

                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container` : `form-wrapper filter-container filter-hide`}>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Identificao Solicitacao'} name={'IdentificaoSolicitacao'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Contato'} name={'Contato'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Endereço'} name={'Endereco'} register={register} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <Multiselect
                                        placeholder={'Selecione a disciplina'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        selectedValues={disciplinaList.selectedValue} // Preselected value to persist in dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                    />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-9 col-lg-9 p-2">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={reguladora} label={'Reguladora'} name={'idReguladora'} options={reguladoraList} keyValue={'idReguladora'} keyLabel={'reguladora'} paramMethod={getReguladora} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={corretora} label={'Corretora'} name={'idCorretora'} options={corretoraList} keyValue={'idCorretora'} keyLabel={'corretora'} paramMethod={getCorretora} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={tipoSinistro} label={'Tipo Sinistro'} name={'idTipoSinistro'} options={sinisterType} keyValue={'key'} keyLabel={'value'} paramMethod={getTipoSinistro} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={porteSinistro} label={'Porte Sinistro'} name={'idPorteSinistro'} options={sinisterPort} keyValue={'key'} keyLabel={'value'} paramMethod={getPorteSinistro} />
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-4 col-lg-4 p-2">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'Idstatus'} options={sinisterStatus} keyValue={'key'} keyLabel={'value'} paramMethod={getstatus} />
                                </div>

                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 p-2">
                                    <DateRangeInput
                                        vertical="false"
                                        onDatesChange={data => dispatch({ type: 'dateChange', payload: data })}
                                        onFocusChange={focusedInput => dispatch({ type: 'focusChange', payload: focusedInput })}
                                        startDate={state.startDate} // Date or null
                                        endDate={state.endDate} // Date or null
                                        focusedInput={state.focusedInput} // START_DATE, END_DATE or null
                                    />
                                </div>

                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <input className='default-button' value='Limpar' type="button" onClick={() => {
                                        reset({
                                            IdentificaoSolicitacao: '',
                                            Segurado: '',
                                            Contato: '',
                                            Endereco: ''
                                        });
                                        setDisciplina(['Selecione a disciplina']);
                                        setCliente(['Selecione o cliente']);
                                        setReguladora(['Reguladora']);
                                        setCorretora(['Corretora']);
                                        setTipoSinistro(['Tipo Sinistro']);
                                        setPorteSinistro(['Porte Sinistro']);
                                        setstatus(['Status']);
                                        multiselectRef.current.resetSelectedValues();
                                    }} />
                                </div>

                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <ButtonOutline
                                        type={"submit"}
                                        outlineColor={"#EE4B21"}
                                        backgroundColor={"white"}
                                        color={"#EE4B21"}
                                        text={"Pesquisar"}
                                    />
                                </div>
                            </div>

                        </StyledForm>

                        {/* <StldRow height="250px"> */}
                        <StldRow>
                            {solicitacoesData != null ? solicitacoesData.data.itens.map((item, index) => {
                                return (
                                    <StldColumn key={index} xs="12" sm="6" md="3">
                                        <CardSolicitacaoOptions id={item.idSolicitacao} title={item.cliente.clienteNome} subtitle={item.local.local} info={item.tipoSinistro} type={item.disciplinas} />
                                    </StldColumn>
                                )
                            }) : null}
                        </StldRow>
                        {(() => {
                            if (solicitacoesData != null) {
                                return (
                                    <PaginationCustom isMobile={isMobile}
                                        isDesktop={isDesktop}
                                        length={solicitacoesData.data.page.length}
                                        recordsTotal={solicitacoesData.data.page.recordsTotal}
                                        currentPage={currentPage}
                                        formData={formData}
                                        pageSize={pageSize}
                                        setPageSize={setPageSize}
                                        setPage={(page) => setCurrentPage(page)} />
                                )
                            }
                            return null
                        })()}
                    </div>
                    <br />
                </StyledDefaultPage>
            </main>

        </section>
    );
};


export const SolicitacoesPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Solicitacoes />

                </>
            )}
        </>
    );
};
